import { IProductAttribute } from '@models/VendorVariant/i-vendor-variant';

export const attributeWhitelist: { [key: string]: boolean } = {
  care_instructions: true,
  color: true,
  country_of_origin: true,
  description: true,
  designer: true,
  dimensions: true,
  estimated_ship_date: true,
  fill_material: true,
  frame_color: true,
  frame_material: true,
  has_removable_cover: true,
  is_assembly_required: true,
  is_framed: true,
  is_returnable: true,
  is_reversible: true,
  leg_finish: true,
  leg_material: true,
  lighting_has_dimmer: true,
  lighting_shade_included: true,
  material: true,
  metal_finish: true,
  orientation: true,
  outdoor_safe: true,
  rug_construction: true,
  rug_knot_type: true,
  seat_height: true,
  seating_capacity: true,
  set_includes: true,
  shade_color: true,
  ship_surcharge: true,
  size: true,
  sku: true,
  table_height: true,
  thread_count: true,
  throw_pillow_insert_included: true,
  wood_finish: true,
};

export const attributeWhitelistConfigurator: { [key: string]: boolean } = {
  color: true,
  dimensions: true,
  material: true,
};

export const filterWhitelistedAttributes = (
  attributes: IProductAttribute[],
): IProductAttribute[] => attributes.filter(({
  attributeType,
}: IProductAttribute) => !!attributeWhitelist[attributeType.title]);

export const filterWhitelistedAttributesVendorVariant = (
  attributes: IProductAttribute[],
): IProductAttribute[] => attributes.filter(({
  attributeType,
}: IProductAttribute) => !!attributeWhitelistConfigurator[attributeType.title]);

export default filterWhitelistedAttributes;
